import { skipToken, useQuery } from '@tanstack/react-query';

import { useServices } from '@/providers/services-provider';

/** The billing plans, one cached request shared by every page that shows them. */
export const usePlans = (enabled: boolean) => {
  const { api } = useServices();

  return useQuery({
    queryKey: ['billing', 'plans'],
    queryFn: enabled && api ? () => api.getPlans() : skipToken,
  });
};
